import axios from 'axios';

const url = process.env.REACT_APP_API_IA_URL || 'http://localhost:3002';

const api = axios.create({
  baseURL: `${url}`,
});

export default api;
